<template>
  <!-- <div class="stickers-card-wrapper">
      <div class="card-background-wrapper">
        <img class="card-background" :src="`/icons/sticker-bg-${sticker}.jpg`">
        <img class="card-example" :src="templateImageSrc" v-if="sticker != 'custom'">
      </div>
      <div class="">

      </div>
  </div> -->
  <div class="sticker-buy-preview-card">
    <img
      v-if="sticker == 'custom'"
      class="sticker-bg"
      :src="`/icons/sticker-bg-${sticker}.jpg`"
      alt=""
    />
    <template v-else>
      <img
        class="sticker-bg"
        :src="`/icons/sticker-bg-${sticker}.jpg`"
        alt=""
      />
      <img class="sticker-example" :src="templateImageSrc" alt="" />
    </template>

    <div v-if="sticker == 'custom'" class="right-column">
      <div class="column-first-part">
        <div id="scroll-part" class="scroll-part">
          <div class="title">Custom</div>
          <div class="qrw-paragraph-md mt-16 v1-grey-6-color">
            {{ $t("stickers_card.custom_comment") }}
          </div>
        </div>
        <div id="actions-container" class="fixed-part">
          <a href="/packages/custom-sticker-template.svg" download
            ><BaseButton variant="secondary" size="md" color="v1-grey-3" class="w-100" icon="download">{{
              $t("stickers_card.download")
            }}</BaseButton>
          </a>
          <div class="container-box mb-16">
            <div class="qrw-paragraph-md mt-16 v1-grey-6-color">
              {{ $t("stickers_card.format_svg") }}
            </div>
            <div @click="showUploadUI">
              <BaseButton 
                variant="secondary" 
                size="md" 
                color="v1-grey-3" 
                class="w-100 mt-16"
                :disabled="added_to_cart"
                >{{
                  form.custom_url
                    ? $t("stickers_card.uploaded")
                    : $t("stickers_card.upload_custom")
                }}</BaseButton
              >
            </div>

            <input
              type="file"
              accept=".jpg,.png,.svg,.pdf"
              @change="onUpload"
              ref="templateFile"
              v-show="false"
            />
          </div>
          <div class="container-box">
            <div class="border"></div>
            <div class="container-box"></div>
          </div>
          <BaseSelect
            class="mb-15"
            :placeholder="$t('stickers_card.choose_system_ph')"
            v-model="form.system"
          >
            <option value="inside">
              {{ $t("stickers_card.inside_sticker") }}
            </option>
            <option value="direct">
              {{ $t("stickers_card.direct_sticker") }}
            </option>
          </BaseSelect>
          <div class="label" v-if="!form.system">
            {{ $t("stickers_card.choose_system") }}
          </div>
          <div class="mt-16" v-if="form.system">
            <div v-if="form.system == 'direct'">
              <BaseInput
                class="mb-16 w-100"
                fullWidth
                v-model.number="form.count"
                :placeholder="$t('stickers_card.count_ph')"
              />
              <div class="label" v-if="!form.count">
                {{ $t("stickers_card.count") }}
              </div>
            </div>
            <div v-else>
              <BaseSelect
                class="mb-16 w-100"
                fullWidth
                v-model="form.section"
                :placeholder="$t('stickers_card.hall_ph')"
              >
                <option :value="-1">
                  {{ $t("stickers_card.all_halls") }}
                </option>
                <option
                  v-for="(section, index) in cafe.sections"
                  :value="index"
                  :key="index"
                >
                  {{ section.name }}
                </option>
              </BaseSelect>
              <div class="label" v-if="form.section == null && !form.count">
                {{ $t("stickers_card.different_halls") }}
              </div>
            </div>
          </div>

          <DashboardButton
            @click="addToCart"
            v-if="!added_to_cart && (form.section !== null || form.count)"
            class="w-100"
            variant="success-fill"
            >{{ $t("stickers_card.add_btn") }}</DashboardButton
          >
          <DashboardButton
            v-else-if="added_to_cart"
            class="w-100"
            icon="ok"
            variant="black-fill"
            >{{ $t("stickers_card.added") }}</DashboardButton
          >
        </div>
      </div>
    </div>
    <div class="right-column" v-else>
      <div class="column-first-part">
        <div id="scroll-part" class="scroll-part">
          <div class="title">
            {{ sticker.substring(0, 1).toUpperCase() + sticker.substring(1) }}
          </div>
          <div class="comment">
          </div>
        </div>
        <div id="actions-container" class="fixed-part">
          <BaseSelect
            class="mb-15"
            :placeholder="$t('stickers_card.choose_system_ph')"
            v-model="form.system"
          >
            <option value="inside">
              {{ $t("stickers_card.inside_sticker") }}
            </option>
            <option value="direct">
              {{ $t("stickers_card.direct_sticker") }}
            </option>
          </BaseSelect>
          <div class="label" v-if="!form.system">
            {{ $t("stickers_card.choose_system") }}
          </div>
          <div v-if="form.system">
            <div v-if="form.system == 'direct'">
              <BaseInput
                class="w-100 mb-15"
                :readonly="false"
                v-model.number="form.count"
                :placeholder="$t('stickers_card.count_ph')"
              />
              <div class="label" v-if="!added_to_cart">
                {{ $t("stickers_card.count") }}
              </div>
            </div>
            <div v-else>
              <BaseSelect
                v-model="form.section"
                :placeholder="$t('stickers_card.hall_ph')"
              >
                <option :value="-1">
                  {{ $t("stickers_card.all_halls") }}
                </option>
                <option
                  v-for="(section, index) in cafe.sections"
                  :value="index"
                  :key="index"
                >
                  {{ section.name }}
                </option>
              </BaseSelect>
              <div class="label" v-if="form.section == null && !form.count">
                {{ $t("stickers_card.different_halls") }}
              </div>
            </div>
          </div>

          <DashboardButton
            @click="addToCart"
            v-if="!added_to_cart && (form.section !== null || form.count)"
            class="w-100 mt-16"
            variant="success-fill"
            >{{ $t("stickers_card.add_btn") }}</DashboardButton
          >
          <DashboardButton
            v-else-if="added_to_cart"
            class="w-100 mt-16"
            icon="ok"
            variant="black-fill"
            >{{ $t("stickers_card.added") }}</DashboardButton
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardButton from "@/components/DashboardButton.vue";
import BlackSelect from "@/components/BlackSelect.vue";
import BlackInput from "@/components/BlackInput.vue";

import ShipmentAPI from "@/api/shipment";

const FILE_SIZE_LIMIT = 25 * 1024 * 1024;

export default {
  components: {
    DashboardButton,
    BlackSelect,
    BlackInput,
  },
  props: {
    sticker: String,
  },
  data() {
    return {
      form: {
        system: 'inside',
        section: -1,
        count: null,
        custom_url: null,
        template: null,
      },

      added_to_cart: false,
    };
  },
  watch: {
    sticker() {
      this.recacluateBlockHeight();

      this.form = {
        system: 'inside',
        section: -1,
        count: null,
        custom_url: null,
      };
      this.added_to_cart = false;
    },
  },
  methods: {
    recacluateBlockHeight() {
      let fixed = document.getElementById("actions-container");
      let scrollPart = document.getElementById("scroll-part");
      scrollPart.style = `padding-bottom:${fixed.offsetHeight}px`;
    },
    addToCart() {
      this.form.template = this.sticker;
      this.added_to_cart = true;

      this.$emit("purchase", this.form);
    },
    showUploadUI() {
      this.$refs.templateFile.click();
    },
    onUpload() {
      let image_file = this.$refs.templateFile.files[0];

      if (!image_file) return;

      if (image_file.size > FILE_SIZE_LIMIT) {
        alert("File too large!");
        return;
      }

      ShipmentAPI.uploadCustomTemplate(image_file)
        .then((response) => {
          if (!response.data.success) {
            this.$emit("fail", response.data.error);
            return;
          }

          this.$emit("success", response.data.url);
          this.form.custom_url = response.data.url;
        })
        .catch((error) => {
          this.$emit("fail", error);
        });
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    templateImageSrc() {
      const country = this.$store.state.owner.country.toLowerCase();

      const sticker_locale = ["ua", "ru"].includes(country) ? country : "en";
      // const sticker_locale = this.selected_language || 'ua';

      const sticker_type = this.sticker;
      return `/stickers/${sticker_type}-${sticker_locale}.png`;

      // return `/api/shipment/preview/${this.cafe._id}?locale=${sticker_locale}&type=${sticker_type}`;
    },
  },
};
</script>
<style scoped>
.card-background-wrapper {
  position: relative;
}

.card-background {
  width: 500px;
}

.card-example {
  position: absolute;
  bottom: 30px;
  left: 30px;

  width: 280px;
  height: 280px;
  min-width: 280px;
  min-height: 280px;
}

.sticker-example {
  position: absolute;
  bottom: 30px;
  left: 30px;
  width: 280px;
  height: 280px;
  min-height: 280px;
  max-height: 280px;
  border-radius: 8px;
}
.sticker-buy-preview-card {
  position: relative;
  width: 100%;
  background: #1d1d1b;
  border-radius: 1.333vh;
  display: flex;
}
.fixed-part {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 2.222vh;
  background: rgba(29, 29, 27, 0.9);
  backdrop-filter: blur(15px);
  width: 89.6%;
  border-bottom-right-radius: 1.33vh;
}
.scroll-part {
  max-height: 62vh;
  overflow-y: auto;
}
.sticker-bg {
  height: 66.44444444444444vh;
  border-radius: 1.333vh 0 0 1.333vh;
  object-fit: cover;
  width: 66%;
}
.right-column {
  position: relative;
  padding: 2.222vh;
  width: 34%;
}
.title {
  font-size: 4vh;
  line-height: 4.555555555555555vh;
  color: #ededed;
}

.column-first-part {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.label {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
}
.w-100 {
  width: 100%;
}
.mb-10 {
  margin-bottom: 1.1111111111111112vh;
}
.mb-15 {
  margin-bottom: 1.6666666666666667vh;
}
.border {
  width: 100%;
  height: 0.1vh;

  background: #908f8d;
  border-radius: 0.3333333333333333vh;
}

a {
  text-decoration: none;
}
</style>
